import LogRocket from 'logrocket';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logRocketId } from './utils/runtimeConfig';
import { patchResizeObserverLoopLimit } from './utils/patchResizeObserver';
import { configureMonaco } from './utils/configureMonaco';
import { installMonacoLiveRegionMask } from './utils/monacoLiveRegionMask';

// Must run before the app mounts (root.render, below) -- that's when Monaco
// and other ResizeObserver consumers actually get constructed.
patchResizeObserverLoopLimit();
configureMonaco();
// Before LogRocket.init: mutation observers are notified in creation order,
// so the mask reaches Monaco's body-level live region before the recorder.
installMonacoLiveRegionMask();

if (logRocketId) {
  // API traffic includes private build data, assistant transcripts and config.
  // Keep acquisition replay, but never record request or response contents.
  LogRocket.init(logRocketId, { network: { isEnabled: false } });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

reportWebVitals();
